const geolocation = {
  get supported () {
    return 'geolocation' in navigator
  },
  get position () {
    if (!this.supported) return Promise.reject(new Error('geolocation is not supported'))

    return new Promise((resolve, reject) =>
      navigator.geolocation.getCurrentPosition(resolve, reject)
    ).then(({ coords }) => ({ lat: coords.latitude, lng: coords.longitude }))
  }
}

export default geolocation
